const getDays = (numberOfDays) => {
  const days = [];
  if (numberOfDays === parseInt(numberOfDays, 10)) {
    for (let index = 0; index < numberOfDays; index += 1) {
      const incrementValue = index + 1;
      const labelValue = `${incrementValue} days`;
      days[index] = {
        value: incrementValue,
        label: labelValue
      };
    }
  }
  return days;
};

export default getDays;
